import { useMatches } from '@tanstack/react-router';
import { RouteStaticData, RouterContext } from './types';

export function useCurrentRouteStaticData(): RouteStaticData | undefined {
  const matches = useMatches();
  const currentMatch = matches.at(-1);
  const staticData = currentMatch?.staticData;
  const overrides = (currentMatch?.context as RouterContext | undefined)?.staticDataOverrides;

  return overrides ? { ...staticData, ...overrides } : staticData;
}
